import { Decimal } from 'decimal.js';

/**
 * Calculates variance for estimated and actual values, typically from a work order.
 *
 * @param estimated
 * @param actual
 * @returns number representing variance percentage
 *
 * NOTE: will return Infinity when `estimated` is 0 and `actual` is non-zero
 */
export function calcVarianceDecimal(
  estimated: Decimal,
  actual: Decimal,
): Decimal {
  // short circuit to skip calculating a zero variance and to avoid returning NaN when both are zero
  if (estimated.eq(actual)) {
    return new Decimal('0');
  }

  const difference = estimated.sub(actual);
  const variance = difference.div(estimated).mul(new Decimal('100')).round();

  return variance.eq(new Decimal('0')) ? new Decimal('0') : variance;
}
